export const MAX_REPORT_QUERY_BYTES = 2048;
export const REPORT_QUERY_TOO_LARGE_MESSAGE = 'Too many filters selected. Reduce the selection and try again.';

export function isReportQueryWithinLimit(params: URLSearchParams): boolean {
  // URLSearchParams serializes to percent-encoded ASCII, so each character is one byte.
  return params.toString().length <= MAX_REPORT_QUERY_BYTES;
}
